import { useAttention } from '../context/AttentionContext';
import { Dialog, Icon, IconButton } from './ui';
import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ThemeToggle } from '../context/ThemeContext';
import BrandMark from './BrandMark';

export default function AppShell({ children, session = false }) {
  const { user, logout } = useAuth();
  const attention = useAttention();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [sessionCollapsed, setSessionCollapsed] = useState(true);
  const navigationCollapsed = session ? sessionCollapsed : collapsed;
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);
  const links = [
    ['/', 'projects', 'Проекты'],
    ['/attention', 'chat', 'Нужны мои действия'],
    ['/my-skills', 'skills', 'Мои скиллы'],
    ...(user?.is_admin ? [
      ['/admin/skills', 'skills', 'Базовые скиллы'],
      ['/agents', 'agents', 'Агенты'],
      ['/admin', 'admin', 'Администрирование'],
    ] : []),
  ];
  const content = <>
    <Link to="/" className="app-brand" aria-label="Agent R&D — проекты"><BrandMark />
      <span className="nav-label">Agent R&D<span className="brand-caption">Рабочее пространство</span></span></Link>
    <div className="nav-section-label nav-label">Рабочее пространство</div>
    <nav aria-label="Основная навигация" className="app-nav">
      {links.map(([to, icon, label]) => <NavLink key={to} to={to} end={to === '/'} title={label}
        className={({ isActive }) => `app-nav-link ${isActive || (to === '/' && location.pathname.startsWith('/projects/')) ? 'active' : ''}`}>
        <Icon name={icon} /><span className="nav-label">{label}</span>
        {to === '/attention' && attention?.data?.total > 0 && <span className="badge" aria-label={`Сессий, требующих действия: ${attention.data.total}`}>{attention.data.total}</span>}
      </NavLink>)}
    </nav>
    <div className="app-sidebar-bottom">
      <NavLink to="/settings" title="Настройки" className={({ isActive }) => `app-nav-link ${isActive ? 'active' : ''}`}>
        <Icon name="settings" /><span className="nav-label">Настройки</span></NavLink>
      <ThemeToggle />
      <div className="account-block">
        <span className="account-avatar" aria-hidden="true">{(user?.display_name || user?.email || 'A').slice(0, 1).toUpperCase()}</span>
        <div className="account-info nav-label"><strong>{user?.display_name || 'Мой аккаунт'}</strong><span>{user?.is_admin ? 'Администратор' : 'Пользователь'}</span></div>
        <IconButton icon="logout" label="Выйти" onClick={logout} />
      </div>
    </div>
  </>;
  return <div className={`app-shell ${navigationCollapsed ? 'is-collapsed' : ''} ${session ? 'is-session' : ''}`}>
    <a className="skip-link" href="#workspace">Перейти к содержимому</a>
    <aside className="app-sidebar">{content}<IconButton className="nav-collapse" icon="collapse"
      label={navigationCollapsed ? 'Развернуть меню' : 'Свернуть меню'} aria-expanded={!navigationCollapsed}
      onClick={() => (session ? setSessionCollapsed : setCollapsed)(value => !value)} /></aside>
    <div className="workspace-column">
      {user?.moderation?.restricted && <div role="status" className="alert alert-error">Аккаунт доступен на чтение. {user.moderation.reasons.join(' ')}</div>}
      <header className="mobile-topbar"><IconButton icon="menu" label="Открыть меню" aria-expanded={mobileOpen} onClick={() => setMobileOpen(true)} />
        <Link to="/" className="mobile-brand" aria-label="Agent R&D — проекты"><BrandMark /><span>Agent R&D</span></Link><ThemeToggle compact /></header>
      <main id="workspace" tabIndex={-1} className={session ? 'session-workspace' : 'main-content'}>{children}</main>
    </div>
    {mobileOpen && <Dialog title="Рабочее пространство" className="nav-drawer" onClose={() => setMobileOpen(false)}>
      <div className="mobile-nav-content">{content}</div>
    </Dialog>}
  </div>;
}
